import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-view-sale-details',
  templateUrl: './view-sale-details.component.html',
  styleUrls: ['./view-sale-details.component.css']
})
export class ViewSaleDetailsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
